import { render, staticRenderFns } from "./DetailBookChapter.vue?vue&type=template&id=6d21150e&scoped=true"
import script from "./DetailBookChapter.vue?vue&type=script&lang=js"
export * from "./DetailBookChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21150e",
  null
  
)

export default component.exports